<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj' : 'Dodaj obiekt' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa obiektu*" />
          </w-schema>
        </v-flex>

        <v-flex md12>
          <v-layout row wrap>
            <v-flex pr-2 xs12 md6>
              <w-schema :model="$schema.city">
                <v-text-field name="name" label="Miasto" @input="setMarkerDebounced" />
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs12 md6>
              <w-schema :model="$schema.postalCode">
                <v-text-field name="name" label="Kod Pocztowy" @input="setMarkerDebounced" />
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.street">
            <v-text-field name="name" label="Ulica" @input="setMarkerDebounced" />
          </w-schema>
        </v-flex>

        <v-flex md12>
          <v-layout row wrap>
            <v-flex pr-2 xs12 md5>
              <w-schema :model="$schema.homeNumber">
                <v-text-field name="name" label="Numer budynku" />
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs12 md5>
              <w-schema :model="$schema.localNumber">
                <v-text-field name="name" label="Numer lokalu" />
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs12 md2>
              <v-btn color="primary" large flat @click="setMarker">Aktualizuj położenie</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <map-component
          v-if="show"
          :tilesUrl="tilesUrl"
          :marker="marker"
          :markerDraggable="true"
          :latModel="$schema.lat"
          :lngModel="$schema.lng"
          :zoom="defaultZoom"
          :center="defaultCenter"
        />

        <v-flex v-if="show" class="mb-4">
          <html-editor :schema="$schema.description" />
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.descriptionShort">
            <v-textarea label="Opis skrócony" />
          </w-schema>
        </v-flex>

        <v-flex v-if="show">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <single-image aspect-ratio="16:9" min-height="300" :schema="$schema.mainImage" />

              <div class="caption">
                * Minimalna wysokość 300 px oraz wymagana proporcja 16:9
              </div>
            </v-flex>

            <v-flex xs12 md6>
              <images-list min-height="150" min-width="150" :schema="$schema.images" />

              <div class="caption">
                * Minimalna rozdzielczość 150x150 px
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { geoResource } from '@witkac/kartamiejska-resources';
import MapComponent from '@witkac/osm-map';
import { WSchema } from '@witkac/vuetify-components';
import debounce from 'debounce';
import { mapState } from 'vuex';

import HtmlEditor from '@/components/forms/HtmlEditor';
import ImagesList from '@/components/forms/ImagesList';
import SingleImage from '@/components/forms/SingleImage';
import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/place.schema';
import { config } from '@/utils/config';

const emptyData = () => ({
  name: '',
  description: '',
  city: '',
  postalCode: '',
  street: '',
  homeNumber: '',
  localNumber: '',
  descriptionShort: '',
  images: '',
  mainImage: null,
  lat: null,
  lng: null
});

// @vuese
// Modal dodawania/edycji obiektu
// @group Partners
export default {
  components: { HtmlEditor, ImagesList, Modal, SingleImage, WSchema, MapComponent },
  mixins: [manageMixin('partners/places', {}, emptyData)],
  schema,
  data() {
    return {
      tilesUrl: config.mapTilesURL
    };
  },
  computed: {
    marker() {
      const { lat, lng, name } = this.$schema.$model;
      if (lat && lng) {
        return { lat, lng, text: name };
      }
    },
    ...mapState({
      stateData: state => state.partners.places.data,
      defaultCenter(state) {
        const { lat, lng } = state.partners.places.data || {};
        const defaultCenterSetting = state.settings.settings.PUBLIC_DEFAULT_CENTER;
        if (lat && lng) {
          return [lat, lng];
        } else if (defaultCenterSetting) {
          return JSON.parse(defaultCenterSetting.value).center;
        }
      },
      defaultZoom(state) {
        const defaultZoomSetting = state.settings.settings.PUBLIC_DEFAULT_MAP_LEVEL;
        if (defaultZoomSetting) {
          return parseInt(defaultZoomSetting.value);
        }
      }
    })
  },
  methods: {
    setMarkerDebounced: debounce(function() {
      this.setMarker();
    }, 500),
    setMarker() {
      const { city, street, postalCode } = this.$schema;
      if (city.$model && street.$model && postalCode.$model) {
        geoResource.search(city.$model, street.$model, postalCode.$model).then(
          result => {
            if (result && result.data.length) {
              const { lat, lon } = result.data[0];
              this.$schema.$setData({ lat: parseFloat(lat), lng: parseFloat(lon) });
            }
          },
          err => this.$store.dispatch('notifyError', { title: 'Nie udało się znaleźć lokalizacji' })
        );
      }
    }
  }
};
</script>
